import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Tooltip } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';

CreditGauge.propTypes = {
  used: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  overspend: PropTypes.number,
};

export default function CreditGauge({ used, total, overspend = 0 }) {
  const theme = useTheme();

  const effectiveTotal = total + overspend;
  const usedPercent = effectiveTotal > 0 ? Math.min((used / effectiveTotal) * 100, 100) : 0;
  const basePercent = effectiveTotal > 0 ? (total / effectiveTotal) * 100 : 100;
  const isOverspending = used > total;

  const getBarColor = () => {
    if (isOverspending) return theme.palette.error.main;
    if (used / total > 0.8) return theme.palette.warning.main;
    return theme.palette.primary.main;
  };
  const barColor = getBarColor();

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {used.toLocaleString()} / {total.toLocaleString()}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {total > 0 ? Math.round((used / total) * 100) : 0}%
        </Typography>
      </Box>
      <Tooltip title={`${used.toLocaleString()} used of ${total.toLocaleString()} total${overspend > 0 ? ` (+${overspend.toLocaleString()} overspend)` : ''}`}>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: 24,
            borderRadius: 1.5,
            backgroundColor: alpha(theme.palette.grey[300], 0.4),
            overflow: 'hidden',
          }}
        >
          {/* Used portion */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              width: `${usedPercent}%`,
              backgroundColor: barColor,
              borderRadius: 1.5,
              transition: 'width 0.6s ease-in-out',
            }}
          />
          {/* Base limit marker when overspend exists */}
          {overspend > 0 && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: `${basePercent}%`,
                height: '100%',
                width: 2,
                backgroundColor: theme.palette.grey[600],
              }}
            />
          )}
        </Box>
      </Tooltip>
    </Box>
  );
}
